// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
body {
  overflow-x: hidden;
}

ul .list-item i {
  margin-top: 0.4rem;
}

form input {
  background-color: var(--bs-secondary) !important;
}

.card:hover {
  transform: scale(1.015);
}

.decoration {
  width: 30px;
  height: 70vh;
  transform: translateY(-50%);
}
.decoration svg {
  height: 100%;
}

.section-title {
  font-weight: bold;
  background-color: var(--bs-primary);
  display: block;
  margin: 0 auto 3rem;
  text-transform: uppercase;
  width: fit-content;
  padding: 0.4rem 0.8rem;
}

#solutions,
#details,
#details-2,
#expertise,
#pricing,
#projects,
#subscribe {
  overflow: initial;
  scroll-margin-top: 120px;
}

#header {
  height: 100dvh;
}
#header .background-container {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
#header .background-container img {
  object-fit: cover;
}
@media (max-width: 768px) {
  #header .background-container img {
    object-position: 80%;
  }
}
#header .navbar {
  border-bottom: 1px solid #4a4747;
}
#header .navbar.fixed-top {
  transition: all 1000ms ease-in-out;
}
#header .navbar .navbar-brand:hover,
#header .navbar .nav-link:hover,
#header .navbar .socials .fa-stack:hover {
  transform: scale(1.03);
}
#header .text-container .btn {
  width: fit-content;
}

#partners .partner-control {
  display: flex;
  justify-content: center;
  align-items: center;
}
#partners .partner-control:hover {
  cursor: pointer;
  transform: scale(1.03);
}

#info p.fs-xl-4 {
  font-size: 1.15rem;
}

#solutions .card-body {
  font-size: 1.15rem;
}

#expertise .point-control .icon-control {
  min-width: 33.33% !important;
}
#expertise .point-control .icon-control i:hover {
  cursor: pointer;
  transform: scale(1.03);
}

#video .fa-stack {
  position: relative;
  font-size: 2rem;
}
#video .fa-stack i.fa-play::before {
  position: absolute;
  transform: translateX(-40%);
}
#video .fa-stack:after {
  position: absolute;
  content: "";
  top: 0;
  left: 10%;
  width: 80%;
  height: 100%;
  border-radius: 50%;
  background-color: var(--bs-primary);
  z-index: -1;
  animation: pulse 1.5s ease infinite;
}
@keyframes pulse {
  0% {
    scale: 1;
    opacity: 1;
  }
  100% {
    scale: 1.6;
    opacity: 0;
  }
}

#video .modal-dialog {
  max-width: 1000px !important;
}

#pricing .shopping-card {
  cursor: pointer;
  text-decoration: none;
  max-width: 395px;
  height: 100%;
}

#projects .project-control {
  cursor: pointer;
}

#footer .social-icons i {
  color: var(--bs-body-color) !important;
}
#footer .social-icons i:hover {
  transform: scale(1.025);
  color: var(--bs-primary) !important;
}

a.fixed-bottom {
  width: fit-content !important;
  left: auto;
  width: 40px;
  height: 40px;
  padding: 0.5rem 0.6rem;
  background-color: #fff;
  scale: 1.2;
  transition: opacity 300ms ease-in-out;
}
a.fixed-bottom.show {
  opacity: 1 !important;
}
a.fixed-bottom:hover {
  scale: 1.3;
}

#inner-page #about .cards-container {
  max-width: 1100px !important;
}
#inner-page #about .card-control .card-body {
  width: fit-content !important;
  font-size: 1rem;
}
#inner-page #about .card-control .card-body h6 {
  font-size: 1rem;
}
#inner-page #privacy .container {
  max-width: 1180px !important;
}
#inner-page #privacy .container .list-group-item {
  margin-bottom: 0 !important;
}
#inner-page #privacy .container .list-group-item p {
  font-size: 1rem !important;
  font-weight: 300 !important;
}
#inner-page #privacy .container .list-group-item ul .ToS.list-group-item:before {
  content: "●";
  margin-right: 0.75rem;
}
@media (max-width: 992px) {
  #inner-page #privacy .container .list-group-item {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
}

@media (min-width: 500px) and (max-width: 575px) {
  .projects-container > div {
    flex-basis: 80%;
  }
}
@media (max-width: 576px) {
  #header .text-container {
    font-size: 1rem;
  }
  #subscribe {
    font-size: 1rem !important;
  }
}
@media (min-width: 664px) {
  #projects .modal-dialog {
    min-width: 80%;
  }
}
@media (min-width: 880px) {
  #projects .modal-dialog {
    min-width: 90%;
    max-width: 90%;
  }
}
@media (min-width: 880px) {
  .navbar {
    padding: 0.6rem 0 !important;
  }
  .navbar .nav-link {
    padding: 0.5rem 0.4rem !important;
    font-size: 0.9rem !important;
    font-weight: 600;
  }
}
@media (min-width: 1200px) {
  #projects .modal-dialog {
    min-width: 1070px;
    max-width: 1070px;
  }
}
@media (max-width: 991px) {
  .nav-link {
    width: fit-content !important;
  }
}
@media (orientation: landscape) and (max-height: 600px) {
  #header {
    height: fit-content;
  }
  #header .overlay {
    opacity: 0.3 !important;
  }
  #header .decoration {
    height: 60vh !important;
    display: block !important;
  }
  #header .navbar {
    padding-bottom: 0 !important;
  }
  #header .navbar .navbar-brand {
    padding-top: 0 !important;
    margin-top: -0.4rem;
  }
  #header .showcase-container {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
  #header .showcase-container .row .showcase-content {
    flex-basis: 50%;
    margin-left: 10%;
    height: 100%;
  }
  #header .showcase-container .text-container {
    margin-top: 0 !important;
    align-items: flex-start !important;
    text-align: left !important;
  }
  #header .showcase-container .text-container .display-4 {
    font-size: 1.5rem !important;
    font-weight: bold;
  }
  #header .showcase-container .text-container p.lead {
    text-align: left !important;
    font-size: 1.1rem !important;
    margin-bottom: 0;
  }
  #header .showcase-container .text-container .btn {
    font-size: 1rem !important;
    align-self: flex-start !important;
  }
  #about .about-content {
    flex-basis: 100% !important;
    margin-left: 0 !important;
  }
  #details-2 .col-mlg-6, #details .col-mlg-6, #info .col-mlg-6 {
    flex-basis: 50% !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding: 0 1rem !important;
  }
  #details-2 .col-mlg-6 .text-container h2, #details .col-mlg-6 .text-container h2, #info .col-mlg-6 .text-container h2,
  #details-2 .col-mlg-6 .text-container h3,
  #details .col-mlg-6 .text-container h3,
  #info .col-mlg-6 .text-container h3,
  #details-2 .col-mlg-6 .text-container p,
  #details .col-mlg-6 .text-container p,
  #info .col-mlg-6 .text-container p {
    width: 100% !important;
    text-align: left !important;
  }
  #details-2 .col-mlg-6 .text-container hr, #details .col-mlg-6 .text-container hr, #info .col-mlg-6 .text-container hr {
    margin-right: auto !important;
  }
  #details-2 .col-mlg-6 .text-container ul li, #details .col-mlg-6 .text-container ul li, #info .col-mlg-6 .text-container ul li {
    width: 100% !important;
    font-size: 1rem;
  }
  #info form {
    margin-top: 4.5rem !important;
  }
  #details-2 .row, #details .row {
    flex-direction: row !important;
    padding: 0 1rem !important;
  }
  #details-2 .row .col-mlg-6, #details .row .col-mlg-6 {
    width: 50% !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  #details-2 .row .col-mlg-6 .text-container, #details .row .col-mlg-6 .text-container {
    font-size: 1rem;
  }
  #details-2 .row .col-mlg-6 .text-container p.lead, #details .row .col-mlg-6 .text-container p.lead {
    font-size: 1rem;
  }
  #details-2 .row .col-mlg-6 .image-container, #details .row .col-mlg-6 .image-container {
    margin-top: 7.5rem !important;
  }
  #details-2 .decoration, #details .decoration {
    display: none !important;
  }
  #details-2 .row {
    flex-direction: row-reverse !important;
  }
  #details-2 .row .col-mlg-6 .text-container h2 {
    margin-left: -4rem !important;
  }
  #expertise .row .col-11 {
    width: 50% !important;
  }
  #expertise .row .col-11 .point-control {
    flex-direction: column !important;
    align-items: center !important;
    text-align: center;
    gap: 1.5rem !important;
  }
  #expertise .row .col-11 .point-control .icon-control {
    align-self: center !important;
  }
  #expertise .row .col-11 .point-control .text-content {
    max-width: 90%;
  }
  #pricing .row .col-control {
    width: 50%;
  }
  #video .video-container img {
    max-height: 90dvh !important;
  }
  #video .modal,
  #video .ratio,
  #video .modal-body,
  #video .modal-dialog {
    margin-top: 0;
    padding-top: 0;
  }
  #video .modal {
    overflow-y: hidden;
    margin-top: 1rem;
  }
  #video .modal .ratio {
    max-height: 90dvh !important;
  }
  #projects .modal-dialog {
    max-width: 90%;
    margin-top: 1rem !important;
  }
  #projects .modal-dialog .modal-body .col-mlg-6 {
    width: 50% !important;
    margin-top: 0;
    font-size: 1rem !important;
  }
  #projects .modal-dialog .modal-body .col-mlg-6 img {
    margin-top: 3.5rem;
  }
  #projects .modal-dialog .modal-body .col-mlg-6 .text-container {
    text-align: left !important;
  }
  #projects .modal-dialog .modal-body .col-mlg-6 .buttons {
    justify-content: flex-start !important;
    gap: 0.75rem !important;
  }
  #projects .modal-dialog .modal-body .col-mlg-6 .buttons .btn {
    font-size: 1rem;
  }
  #subscribe .col-md-10 {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/scss/style.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,kBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,gDAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,2BAAA;AACF;AACE;EACE,YAAA;AACJ;;AAGA;EACE,iBAAA;EACA,mCAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;AAAF;;AAGA;;;;;;;EAOE,iBAAA;EACA,wBAAA;AAAF;;AAIA;EACE,cAAA;AADF;AAGE;EACE,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AADJ;AAGI;EACE,iBAAA;AADN;AAII;EACE;IACE,oBAAA;EAFN;AACF;AAME;EACE,gCAAA;AAJJ;AAMI;EACE,kCAAA;AAJN;AAOI;;;EAGE,sBAAA;AALN;AAUI;EACE,kBAAA;AARN;;AAcE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAXJ;AAaI;EACE,eAAA;EACA,sBAAA;AAXN;;AAiBE;EACE,kBAAA;AAdJ;;AAmBE;EACE,kBAAA;AAhBJ;;AAqBE;EACE,4BAAA;AAlBJ;AAoBI;EACE,eAAA;EACA,sBAAA;AAlBN;;AAwBE;EACE,kBAAA;EACA,eAAA;AArBJ;AAuBI;EACE,kBAAA;EACA,2BAAA;AArBN;AAwBI;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,WAAA;EACA,mCAAA;AAtBN;AAyBI;EACE;IACE,QAAA;IACA,UAAA;EAvBN;EAyBI;IACE,UAAA;IACA,UAAA;EAvBN;AACF;;AA6BE;EACE,4BAAA;AA1BJ;;AAiCE;EACE,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;AA9BJ;;AAmCE;EACE,eAAA;AAhCJ;;AAsCI;EACE,sCAAA;AAnCN;AAoCM;EACE,uBAAA;EACA,mCAAA;AAlCR;;AAyCA;EACE,6BAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,UAAA;EACA,qCAAA;AAtCF;AAwCE;EACE,qBAAA;AAtCJ;AAyCE;EACE,UAAA;AAvCJ;;AA6CI;EACE,4BAAA;AA1CN;AA8CM;EACE,6BAAA;EACA,eAAA;AA5CR;AA8CQ;EACE,eAAA;AA5CV;AAmDI;EACE,4BAAA;AAjDN;AAmDM;EACE,2BAAA;AAjDR;AAmDQ;EACE,0BAAA;EACA,2BAAA;AAjDV;AAoDQ;EACE,YAAA;EACA,qBAAA;AAlDV;AAqDQ;EAbF;IAcI,oBAAA;IACA,qBAAA;EAlDR;AACF;;AAyDA;EACE;IACE,eAAA;EAtDF;AACF;AAyDA;EACE;IACE,eAAA;EAvDF;EA0DA;IACE,0BAAA;EAxDF;AACF;AA2DA;EACE;IACE,cAAA;EAzDF;AACF;AA4DA;EACE;IACE,cAAA;IACA,cAAA;EA1DF;AACF;AA6DA;EACE;IACE,4BAAA;EA3DF;EA6DE;IACE,iCAAA;IACA,4BAAA;IACA,gBAAA;EA3DJ;AACF;AA8DA;EACE;IACE,iBAAA;IACA,iBAAA;EA5DF;AACF;AA+DA;EACE;IACE,6BAAA;EA7DF;AACF;AAgEA;EACE;IACE,mBAAA;EA9DF;EAgEE;IACE,uBAAA;EA9DJ;EAiEE;IACE,uBAAA;IACA,yBAAA;EA/DJ;EAkEE;IACE,4BAAA;EAhEJ;EAkEI;IACE,yBAAA;IACA,mBAAA;EAhEN;EAoEE;IACE,iBAAA;IACA,oBAAA;EAlEJ;EAoEI;IACE,eAAA;IACA,gBAAA;IACA,YAAA;EAlEN;EAqEI;IACE,wBAAA;IACA,kCAAA;IACA,2BAAA;EAnEN;EAqEM;IACE,4BAAA;IACA,iBAAA;EAnER;EAsEM;IACE,2BAAA;IACA,4BAAA;IACA,gBAAA;EApER;EAuEM;IACE,0BAAA;IACA,iCAAA;EArER;EA4EE;IACE,2BAAA;IACA,yBAAA;EA1EJ;EA+EE;IACE,0BAAA;IACA,yBAAA;IACA,0BAAA;IACA,0BAAA;EA7EJ;EAgFM;;;;;;;IAGE,sBAAA;IACA,2BAAA;EA1ER;EA4EM;IACE,6BAAA;EA1ER;EA6EM;IACE,sBAAA;IACA,eAAA;EA3ER;EAmFE;IACE,6BAAA;EAjFJ;EAsFE;IACE,8BAAA;IACA,0BAAA;EApFJ;EAsFI;IACE,qBAAA;IACA,yBAAA;IACA,0BAAA;EApFN;EAsFM;IACE,eAAA;EApFR;EAsFQ;IACE,eAAA;EApFV;EAuFM;IACE,6BAAA;EArFR;EA0FE;IACE,wBAAA;EAxFJ;EAqGE;IACE,sCAAA;EAnGJ;EAuGQ;IACE,6BAAA;EArGV;EA6GE;IACE,qBAAA;EA3GJ;EA6GI;IACE,iCAAA;IACA,8BAAA;IACA,kBAAA;IACA,sBAAA;EA3GN;EA6GM;IACE,6BAAA;EA3GR;EA8GM;IACE,cAAA;EA5GR;EAmHE;IACE,UAAA;EAjHJ;EAuHI;IACE,4BAAA;EArHN;EAyHE;;;;IAIE,aAAA;IACA,cAAA;EAvHJ;EA0HE;IACE,kBAAA;IACA,gBAAA;EAxHJ;EA0HI;IACE,4BAAA;EAxHN;EA6HA;IACE,cAAA;IACA,2BAAA;EA3HF;EA6HE;IACE,qBAAA;IACA,aAAA;IACA,0BAAA;EA3HJ;EA6HI;IACE,kBAAA;EA3HN;EA8HI;IACE,2BAAA;EA5HN;EA+HI;IACE,sCAAA;IACA,uBAAA;EA7HN;EA+HM;IACE,eAAA;EA7HR;EAoIE;IACE,UAAA;IACA,iBAAA;IACA,kBAAA;EAlIJ;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600;700&display=swap');\n\nbody {\n  overflow-x: hidden;\n}\n\nul .list-item i {\n  margin-top: 0.4rem;\n}\n\nform input {\n  background-color: var(--bs-secondary) !important;\n}\n\n.card:hover {\n  transform: scale(1.015);\n}\n\n.decoration {\n  width: 30px;\n  height: 70vh;\n  transform: translateY(-50%);\n\n  svg {\n    height: 100%;\n  }\n}\n\n.section-title {\n  font-weight: bold;\n  background-color: var(--bs-primary);\n  display: block;\n  margin: 0 auto 3rem;\n  text-transform: uppercase;\n  width: fit-content;\n  padding: 0.4rem 0.8rem;\n}\n\n#solutions,\n#details,\n#details-2,\n#expertise,\n#pricing,\n#projects,\n#subscribe {\n  overflow: initial;\n  scroll-margin-top: 120px;\n}\n\n// ------------------------------\n#header {\n  height: 100dvh;\n\n  .background-container {\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n\n    img {\n      object-fit: cover;\n    }\n\n    @media (max-width: 768px) {\n      img {\n        object-position: 80%;\n      }\n    }\n  }\n\n  .navbar {\n    border-bottom: 1px solid #4a4747;\n\n    &.fixed-top {\n      transition: all 1000ms ease-in-out;\n    }\n\n    .navbar-brand:hover,\n    .nav-link:hover,\n    .socials .fa-stack:hover {\n      transform: scale(1.03);\n    }\n  }\n\n  .text-container {\n    .btn {\n      width: fit-content;\n    }\n  }\n}\n\n#partners {\n  .partner-control {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &:hover {\n      cursor: pointer;\n      transform: scale(1.03);\n    }\n  }\n}\n\n#info {\n  p.fs-xl-4 {\n    font-size: 1.15rem;\n  }\n}\n\n#solutions {\n  .card-body {\n    font-size: 1.15rem;\n  }\n}\n\n#expertise {\n  .point-control .icon-control {\n    min-width: 33.33% !important;\n\n    i:hover {\n      cursor: pointer;\n      transform: scale(1.03);\n    }\n  }\n}\n\n#video {\n  .fa-stack {\n    position: relative;\n    font-size: 2rem;\n\n    i.fa-play::before {\n      position: absolute;\n      transform: translateX(-40%);\n    }\n\n    &:after {\n      position: absolute;\n      content: '';\n      top: 0;\n      left: 10%;\n      width: 80%;\n      height: 100%;\n      border-radius: 50%;\n      background-color: var(--bs-primary);\n      z-index: -1;\n      animation: pulse 1.5s ease infinite;\n    }\n\n    @keyframes pulse {\n      0% {\n        scale: 1;\n        opacity: 1;\n      }\n      100% {\n        scale: 1.6;\n        opacity: 0;\n      }\n    }\n  }\n}\n\n#video {\n  .modal-dialog {\n    max-width: 1000px !important;\n  }\n}\n\n//------------------------\n\n#pricing {\n  .shopping-card {\n    cursor: pointer;\n    text-decoration: none;\n    max-width: 395px;\n    height: 100%;\n  }\n}\n\n#projects {\n  .project-control {\n    cursor: pointer;\n  }\n}\n\n#footer {\n  .social-icons {\n    i {\n      color: var(--bs-body-color) !important;\n      &:hover {\n        transform: scale(1.025);\n        color: var(--bs-primary) !important;\n      }\n    }\n  }\n}\n\n// Sticky Scroll to top Button\na.fixed-bottom {\n  width: fit-content !important;\n  left: auto;\n  width: 40px;\n  height: 40px;\n  padding: 0.5rem 0.6rem;\n  background-color: #fff;\n  scale: 1.2;\n  transition: opacity 300ms ease-in-out;\n\n  &.show {\n    opacity: 1 !important;\n  }\n\n  &:hover {\n    scale: 1.3;\n  }\n}\n\n#inner-page {\n  #about {\n    .cards-container {\n      max-width: 1100px !important;\n    }\n\n    .card-control {\n      .card-body {\n        width: fit-content !important;\n        font-size: 1rem;\n\n        h6 {\n          font-size: 1rem;\n        }\n      }\n    }\n  }\n\n  #privacy {\n    .container {\n      max-width: 1180px !important;\n\n      .list-group-item {\n        margin-bottom: 0 !important;\n\n        p {\n          font-size: 1rem !important;\n          font-weight: 300 !important;\n        }\n\n        ul .ToS.list-group-item:before {\n          content: '●';\n          margin-right: 0.75rem;\n        }\n\n        @media (max-width: 992px) {\n          padding-left: 0.5rem;\n          padding-right: 0.5rem;\n        }\n      }\n    }\n  }\n}\n\n//  Media Queries -----------------------------\n@media (min-width: 500px) and (max-width: 575px) {\n  .projects-container > div {\n    flex-basis: 80%;\n  }\n}\n\n@media (max-width: 576px) {\n  #header .text-container {\n    font-size: 1rem;\n  }\n\n  #subscribe {\n    font-size: 1rem !important;\n  }\n}\n\n@media (min-width: 664px) {\n  #projects .modal-dialog {\n    min-width: 80%;\n  }\n}\n\n@media (min-width: 880px) {\n  #projects .modal-dialog {\n    min-width: 90%;\n    max-width: 90%;\n  }\n}\n\n@media (min-width: 880px) {\n  .navbar {\n    padding: 0.6rem 0 !important;\n\n    .nav-link {\n      padding: 0.5rem 0.4rem !important ;\n      font-size: 0.9rem !important;\n      font-weight: 600;\n    }\n  }\n}\n@media (min-width: 1200px) {\n  #projects .modal-dialog {\n    min-width: 1070px;\n    max-width: 1070px;\n  }\n}\n\n@media (max-width: 991px) {\n  .nav-link {\n    width: fit-content !important;\n  }\n}\n\n@media (orientation: landscape) and (max-height: 600px) {\n  #header {\n    height: fit-content;\n\n    .overlay {\n      opacity: 0.3 !important;\n    }\n\n    .decoration {\n      height: 60vh !important;\n      display: block !important;\n    }\n\n    .navbar {\n      padding-bottom: 0 !important;\n\n      .navbar-brand {\n        padding-top: 0 !important;\n        margin-top: -0.4rem;\n      }\n    }\n\n    .showcase-container {\n      padding-top: 3rem;\n      padding-bottom: 3rem;\n\n      .row .showcase-content {\n        flex-basis: 50%;\n        margin-left: 10%;\n        height: 100%;\n      }\n\n      .text-container {\n        margin-top: 0 !important;\n        align-items: flex-start !important;\n        text-align: left !important;\n\n        .display-4 {\n          font-size: 1.5rem !important;\n          font-weight: bold;\n        }\n\n        p.lead {\n          text-align: left !important;\n          font-size: 1.1rem !important;\n          margin-bottom: 0;\n        }\n\n        .btn {\n          font-size: 1rem !important;\n          align-self: flex-start !important;\n        }\n      }\n    }\n  }\n\n  #about {\n    .about-content {\n      flex-basis: 100% !important;\n      margin-left: 0 !important;\n    }\n  }\n\n  %landscape-shared {\n    .col-mlg-6 {\n      flex-basis: 50% !important;\n      margin-left: 0 !important;\n      margin-right: 0 !important;\n      padding: 0 1rem !important;\n\n      .text-container {\n        h2,\n        h3,\n        p {\n          width: 100% !important;\n          text-align: left !important;\n        }\n        hr {\n          margin-right: auto !important;\n        }\n\n        ul li {\n          width: 100% !important;\n          font-size: 1rem;\n        }\n      }\n    }\n  }\n\n  #info {\n    @extend %landscape-shared;\n    form {\n      margin-top: 4.5rem !important;\n    }\n  }\n\n  %landscape-details {\n    .row {\n      flex-direction: row !important;\n      padding: 0 1rem !important;\n\n      .col-mlg-6 {\n        width: 50% !important;\n        margin-left: 0 !important;\n        margin-right: 0 !important;\n\n        .text-container {\n          font-size: 1rem;\n\n          p.lead {\n            font-size: 1rem;\n          }\n        }\n        .image-container {\n          margin-top: 7.5rem !important;\n        }\n      }\n    }\n\n    .decoration {\n      display: none !important;\n    }\n  }\n\n  #details {\n    @extend %landscape-shared;\n    @extend %landscape-details;\n  }\n\n  #details-2 {\n    @extend %landscape-shared;\n    @extend %landscape-details;\n\n    .row {\n      flex-direction: row-reverse !important;\n\n      .col-mlg-6 {\n        .text-container {\n          h2 {\n            margin-left: -4rem !important;\n          }\n        }\n      }\n    }\n  }\n\n  #expertise {\n    .row .col-11 {\n      width: 50% !important;\n\n      .point-control {\n        flex-direction: column !important;\n        align-items: center !important;\n        text-align: center;\n        gap: 1.5rem !important;\n\n        .icon-control {\n          align-self: center !important;\n        }\n\n        .text-content {\n          max-width: 90%;\n        }\n      }\n    }\n  }\n\n  #pricing {\n    .row .col-control {\n      width: 50%;\n    }\n  }\n\n  #video {\n    .video-container {\n      img {\n        max-height: 90dvh !important ;\n      }\n    }\n\n    .modal,\n    .ratio,\n    .modal-body,\n    .modal-dialog {\n      margin-top: 0;\n      padding-top: 0;\n    }\n\n    .modal {\n      overflow-y: hidden;\n      margin-top: 1rem;\n\n      .ratio {\n        max-height: 90dvh !important;\n      }\n    }\n  }\n\n  #projects .modal-dialog {\n    max-width: 90%;\n    margin-top: 1rem !important;\n\n    .modal-body .col-mlg-6 {\n      width: 50% !important;\n      margin-top: 0;\n      font-size: 1rem !important;\n\n      img {\n        margin-top: 3.5rem;\n      }\n\n      .text-container {\n        text-align: left !important;\n      }\n\n      .buttons {\n        justify-content: flex-start !important;\n        gap: 0.75rem !important;\n\n        .btn {\n          font-size: 1rem;\n        }\n      }\n    }\n  }\n\n  #subscribe {\n    .col-md-10 {\n      width: 80%;\n      margin-left: auto;\n      margin-right: auto;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
